import { render, staticRenderFns } from "./RevenuePerArticleProperty.vue?vue&type=template&id=333ff266&"
import script from "./RevenuePerArticleProperty.vue?vue&type=script&lang=js&"
export * from "./RevenuePerArticleProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports